import type { LearningPathId, ReviewStatus } from "../types";

// Kuratierte Overrides pro Frage-ID. Haben Vorrang vor der Heuristik in mapRawExercise
// (pathFor/skillTagsFor/normalizeLevel). Befüllt vom question-curator / question-reviewer
// und von Vincent — Frage für Frage, nachvollziehbar.
//
// WICHTIG: reviewStatus erst auf "reviewed" / "beta-ready" setzen, wenn die Frage fachlich
// geprüft ist (question-reviewer-Gate). Strukturelle Zuordnung (pathId/skillTags/level) darf
// vorab gesetzt werden, ohne die Frage damit als geprüft zu deklarieren.
export interface CurationOverride {
  pathId?: LearningPathId;
  skillTags?: string[];
  level?: number;
  errorCategory?: string;
  reviewStatus?: ReviewStatus;
}

export const curationOverrides: Record<string, CurationOverride> = {
  // Beispiel (Muster für den question-curator, bewusst noch nicht aktiviert):
  // "hj-bgbat-001": { pathId: "hagen-jura", skillTags: ["bgb-at"], level: 2, reviewStatus: "reviewed" },
};
